import { ErrorSidePanel } from '@/components/errors';
import { formatPhone, loadHistoryState } from '@/lib';
import { groupServiceAccounts } from '@/routes/(services)/-model/group-service-accounts';
import {
  ErrorCodes,
  ImageProfile,
  mage,
  templates,
  type SkinPageConfig,
} from '@nosinovacao/nosid-mfe-common';
import { useQueryClient } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { successStateSchema } from '../-model/flow';
import { type SuccessProps } from '../-model/props';
import { SuccessLight } from './-skins';

export const Route = createFileRoute('/(services)/services/_sheet/switch-services/success/')({
  loader: loadHistoryState(successStateSchema, { errorCode: ErrorCodes.AccessDenied }),
  component: RouteComponent,
  errorComponent: ErrorSidePanel,
});

function RouteComponent() {
  const { services } = Route.useLoaderData();
  const navigate = useNavigate();
  const client = useQueryClient();
  const [loading, setLoading] = useState(false);

  function handleDone() {
    setLoading(true);
    client.invalidateQueries().finally(() => {
      setLoading(false);
      navigate({ to: '/services' });
    });
  }

  const name = services.Holder.PrimaryUserDisplayName;
  const image = mage.getImage(services.Holder.PictureUri, ImageProfile.App) ?? '';
  const email = services.Holder.UsernameAliases.find(
    (alias: { Type: string; Username: string }) => alias.Type === 'Email',
  )?.Username;
  const phone = services.Holder.UsernameAliases.find(
    (alias: { Type: string; Username: string }) => alias.Type === 'Mobile',
  )?.Username;
  const contact = email ? email : phone ? formatPhone(phone ?? '') : undefined;
  const serviceAccounts = groupServiceAccounts(services.Holder.ServiceAccounts).map(
    (sa: { Id: string; Package: string; Address: string }) => ({
      Id: sa.Id,
      Package: sa.Package,
      Address: sa.Address,
    }),
  );

  const props: SuccessProps = {
    holderName: name,
    holderImage: image,
    contact,
    isPrimary: services.Type === 'Primary',
    serviceAccounts,
    loading,
    onDone: handleDone,
  };
  return templates.getSkinSelector(skinConfig(props));
}

function skinConfig(props: SuccessProps): SkinPageConfig {
  return {
    skins: [],
    defaultValue: <SuccessLight {...props} />,
  };
}
